/**
 * `990 MB`, `1.2 GB`, `31.5 MB`: a file size in decimal units with at most one decimal, as
 * Meta and the browser's file pickers count. The server words its refusals the same way
 * (`shared::meta_video::size_words`), so the editor and the API name a limit alike.
 */
export function formatDecimalSize(bytes: number): string {
  const [value, unit] = bytes >= 1e9 ? [bytes / 1e9, 'GB'] : [bytes / 1e6, 'MB'];
  return `${Number(value.toFixed(1))} ${unit}`;
}

/**
 * A file size and the limit it is checked against, as text. When an oversized file rounds
 * to the limit both are given in exact bytes, so a refusal never reads "990 MB (expected
 * ≤ 990 MB)" (`shared::meta_video::size_refusal` does the same).
 */
export function formatSizeAgainstLimit(bytes: number, limit: number): { size: string; limit: string } {
  const size = formatDecimalSize(bytes);
  const max = formatDecimalSize(limit);
  if (bytes > limit && size === max) {
    return { size: `${bytes.toLocaleString('en-US')} bytes`, limit: `${limit.toLocaleString('en-US')} bytes` };
  }
  return { size, limit: max };
}
